import { User } from "api/types";
import { capitalizeFirstLetter, formatDate } from "utils/util";

const yesNoConvert = (data: Boolean | null) => {
  if (data === null) {
    return "N/A";
  } else {
    return data ? "Yes" : "No";
  }
}

const getPreferredNumber = (user: User, preferredNumber: String) => {
  const { clientProfile, mobile } = user;
  if (!clientProfile) return "N/A";
  switch (preferredNumber) {
    case "Mobile":
      return mobile;
    case "Telephone 1":
      return clientProfile.telephoneNumber1;
    case "Telephone 2":
      return clientProfile.telephoneNumber2;
    default:
      return "N/A";
  }
};

export const getPersonalInformationData = (user: User) => [
  [
    { title: "title", value: user.title, columnWidth: 5 },
    { title: "firstName", value: user.firstName, columnWidth: 5 },
    { title: "lastName", value: user.lastName, columnWidth: 5 },
    { title: "preferred Name", value: capitalizeFirstLetter(user.clientProfile?.preferredName || "N/A"), columnWidth: 5 },
    { title: "age", value: user.clientProfile?.age || "N/A", columnWidth: 5 }
  ],
  [
    { title: "gender", value: user.clientProfile?.gender, columnWidth: 5 },
    { title: "country of birth", value: capitalizeFirstLetter(user.clientProfile?.birthCountry || "N/A"), columnWidth: 5 },
    { title: "home region", value: capitalizeFirstLetter(user.clientProfile?.homeRegion || "N/A"), columnWidth: 5 },
    { title: "preferred language", value: user.clientProfile?.preferredLanguages?.join(", ") || "N/A", columnWidth: 5 },
    { title: "date of birth", value: user.clientProfile?.dob ? formatDate(new Date(user.clientProfile?.dob)) : "N/A", columnWidth: 5 }
  ],
  [
    { title: "marital status", value: capitalizeFirstLetter(user.clientProfile?.maritalStatus || "N/A"), columnWidth: 5 },
    { title: "spouse with EICARE", value: yesNoConvert(user.clientProfile?.spouseWithEicare), columnWidth: 5 },
    { title: "spouse name", value: capitalizeFirstLetter(user.clientProfile?.spouseName || "N/A"), columnWidth: 5 },
    { title: "interpreter required", value: yesNoConvert(user.clientProfile?.interpreterRequired), columnWidth: 5 },
    { title: "religion", value: capitalizeFirstLetter(user.clientProfile?.religion || "N/A"), columnWidth: 5 }
  ],
  [
    { title: "", value: (<div className="text-base mt-5">Tenancy</div>)}
  ],
  [
    { title: "landlord", value: yesNoConvert(user.clientProfile?.landlord), columnWidth: 5 },
    { title: "keylock number", value: user.clientProfile?.keylockNumber || "N/A", columnWidth: 5 },
    { title: "not at home note", value: capitalizeFirstLetter(user.clientProfile?.notAtHomeNote || "N/A"), columnWidth: 1 }
  ],
  [
    { title: "", value: (<div className="text-base mt-5">Mobility</div>)}
  ],
  [
    { title: "has a car", value: yesNoConvert(user.clientProfile?.haveACar), columnWidth: 5 },
    { title: "driving", value: yesNoConvert(user.clientProfile?.driving), columnWidth: 5 },
    { title: "disabled parking sticker", value: yesNoConvert(user.clientProfile?.disabledParkingSticker), columnWidth: 5 },
    { title: "taxi card", value: yesNoConvert(user.clientProfile?.haveTaxiCard), columnWidth: 5 },
    { title: "require taxi card", value: yesNoConvert(user.clientProfile?.needTaxiCardFromEicare), columnWidth: 5 }
  ],
  [
    { title: "received taxi card", value: yesNoConvert(user.clientProfile?.taxiCardReceived), columnWidth: 1 }
  ],
  [
    { title: "", value: (<div className="text-base mt-5">Identification</div>)}
  ],
  [
    { title: "aged care id", value: user.clientProfile?.agedCareId || "N/A", columnWidth: 5 },
    { title: "medicare card number", value: user.clientProfile?.medicareCardNo || "N/A", columnWidth: 5 },
    { title: "medicare expiry", value: user.clientProfile?.medicareExpiryDate ? formatDate(new Date(user.clientProfile?.medicareExpiryDate)) : "N/A", columnWidth: 5 },
    { title: "client recipient id", value: user.clientProfile?.clientRecipientId || "N/A", columnWidth: 5 },
    { title: "centrelink number", value: user.clientProfile?.centrelinkNo || "N/A", columnWidth: 5 }
  ],
  [
    { title: "aboriginal or tsi", value: capitalizeFirstLetter(user.clientProfile?.aboriginalTSIStatus || "N/A"), columnWidth: 1 }
  ],
];

export const getContactInformationData = (user: User) => [
  [
    { title: "", value: (<div className="text-base">Client contact</div>)}
  ],
  [
    { title: "mobile", value: user.mobile || "N/A", columnWidth: 5 },
    { title: "telephone number 1", value: user.clientProfile?.telephoneNumber1 || "N/A", columnWidth: 5 },
    { title: "telephone number 2", value: user.clientProfile?.telephoneNumber2 || "N/A", columnWidth: 5 },
    { title: "preferred number", value: getPreferredNumber(user, user.clientProfile?.preferredNumber) || "N/A", columnWidth: 5 },
    { title: "email", value: user.email || "N/A", columnWidth: 5 }
  ],
  [
    { title: "", value: (<div className="text-base mt-5">Primary contact</div>)}
  ],
  [
    { title: "title", value: user.clientProfile?.pTitle || "N/A", columnWidth: 5 },
    { title: "firstname", value: user.clientProfile?.pFirstName || "N/A", columnWidth: 5 },
    { title: "lastname", value: user.clientProfile?.pLastName || "N/A", columnWidth: 5 },
    { title: "gender", value: user.clientProfile?.pGender || "N/A", columnWidth: 5 },
    { title: "relationship", value: user.clientProfile?.pRelationship || "N/A", columnWidth: 5 }
  ],
  [
    { title: "mobile", value: user.clientProfile?.pMobile || "N/A", columnWidth: 5 },
    { title: "telephone number 1", value: user.clientProfile?.pTelephoneNumber1 || "N/A", columnWidth: 5 },
    { title: "telephone number 2", value: user.clientProfile?.pTelephoneNumber2 || "N/A", columnWidth: 5 },
    { title: "preferred number", value: getPreferredNumber(user, user.clientProfile?.pPreferredNumber) || "N/A", columnWidth: 5 },
    { title: "email", value: user.clientProfile?.pEmail || "N/A", columnWidth: 5 }
  ],
];

export const getResidentialAndMailingDetailsInformationData = (user: User) => [
  [
    { title: "", value: (<div className="text-base">Residential address</div>), columnWidth: 5 },
    { title: "", value: (<div className="text-blue-500">Convergence 2, Unit 3, 2 Rose Street, Clayton VIC 3168</div>), columnWidth: 1 }
  ],
  [
    { title: "building name", value: "Convergence", columnWidth: 5 },
    { title: "unit number", value: "3", columnWidth: 5 },
    { title: "street number", value: "2", columnWidth: 5 },
    { title: "street type", value: "Street", columnWidth: 5 },
    { title: "state", value: "VIC", columnWidth: 5 }
  ],
  [
    { title: "", value: (<div className="text-base mt-5">Mailing address</div>), columnWidth: 5 },
    { title: "", value: (<div className="text-blue-500 mt-5">Unit 5, 7 Rose Street, Clayton VIC 3168</div>), columnWidth: 1 }
  ],
  [
    { title: "building name", value: "N/A", columnWidth: 5 },
    { title: "unit number", value: "5", columnWidth: 5 },
    { title: "street number", value: "7", columnWidth: 5 },
    { title: "street type", value: "Street", columnWidth: 5 },
    { title: "state", value: "VIC", columnWidth: 5 }
  ],
  [
    { title: "bUilding number", value: "N/A", columnWidth: 5 },
    { title: "apartment number", value: "N/A", columnWidth: 5 },
    { title: "street name", value: "Rose", columnWidth: 5 },
    { title: "suburb", value: "Clayton", columnWidth: 5 },
    { title: "postcode", value: "3168", columnWidth: 5 }
  ],
];

export const getCarePlanAndCareTeamDetailsInformationData = (user: User) => {
  // const assignedCareTeam = user.clientProfile?.assignedCareTeam;
  const assignedCareTeam = [
    {
      occupation: "Care Coordinator",
      firstName: "Sarah",
      lastName: "Williams",
      phoneNumber: "0412 345 678",
      email: "sarah.williams@careprovider.com.au",
    },
    {
      occupation: "Support Worker",
      firstName: "Michael",
      lastName: "Brown",
      phoneNumber: "0433 567 890",
      email: "michael.brown@careprovider.com.au",
    },
    {
      occupation: "Registered Nurse",
      firstName: "Emma",
      lastName: "Davis",
      phoneNumber: "0455 789 012",
      email: "emma.davis@careprovider.com.au",
    },
  ];

  const careTeamBody = assignedCareTeam && assignedCareTeam.length > 0
    ? assignedCareTeam.map((member) => [
        { value: member.occupation || "N/A", columnWidth: 5 },
        { value: member.firstName || "N/A", columnWidth: 5 },
        { value: member.lastName || "N/A", columnWidth: 5 },
        { value: member.phoneNumber || "N/A", columnWidth: 5 },
        { value: member.email || "N/A", columnWidth: 5 },
      ])
    : [];

  return [
    [
      { title: "My Aged Care Referral Code", value: "R-1234567890AB", columnWidth: 5 },
      { title: "Service Type", value: "Support at home", columnWidth: 5 },
      { title: "Agreement Date", value: "21/10/2025", columnWidth: 5 },
      { title: "Level Assigned", value: "4", columnWidth: 5 },
      { title: "Level Approved", value: "4", columnWidth: 5 },
    ],
    [
      { title: "Referral Issued Date", value: "21/10/2025", columnWidth: 5 },
      { title: "Referral Accepted Date", value: "21/10/2025", columnWidth: 5 },
      { title: "Agreement Document", value: "Signed Agreement.pdf", columnWidth: 5 },
      { title: "Date Assigned", value: "21/10/2025", columnWidth: 5 },
      { title: "Approval Starts Date", value: "21/10/2025", columnWidth: 5 },
    ],
    [
      { title: "Comprehensive Assessment", value: "Comprehensive assessment.pdf", columnWidth: 5 },
      { title: "Support Plan", value: "Support plan.pdf", columnWidth: 5 },
    ],
    [
      { title: "", value: (<div className="text-base mt-3">Assigned care team</div>)}
    ],
    ...(careTeamBody.length > 0
      ? [
          {
            type: "table" as const,
            header: [
              { title: "OCCUPATION", columnWidth: 5 },
              { title: "FIRST NAME", columnWidth: 5 },
              { title: "LAST NAME", columnWidth: 5 },
              { title: "PHONE NUMBER", columnWidth: 5 },
              { title: "EMAIL", columnWidth: 5 },
            ],
            body: careTeamBody,
          },
        ]
      : []),
    [
      { title: "", value: (<div className="text-base mt-8">Service preferences</div>)}
    ],
    [
      { title: "gender of staff", value: "Male", columnWidth: 5 },
      { title: "day", value: "Monday, Wednesday, Friday", columnWidth: 5 },
      { title: "time of day", value: "Late morning 10:00 am - 12:00 pm, Early afternoon 12:00 pm - 2:00 pm", columnWidth: 1 },
    ],
  ];
};